import type * as SchemaTypes from '../types';

import type { WebPageEndpointSpecsFragment } from './WebPageEndpointSpecs';
import type { WebPagePathDataFragment } from './WebPagePathData';
import { gql } from '@apollo/client';
import { WebPageEndpointSpecsFragmentDoc } from './WebPageEndpointSpecs';
import { WebPagePathDataFragmentDoc } from './WebPagePathData';
export type WebpageEndpointContextDataFragment = (
  { __typename: 'WebPageEndpoint' }
  & Pick<SchemaTypes.WebPageEndpoint, 'id' | 'pathname' | 'title' | 'webPageId'>
  & { websiteModule: (
    { __typename: 'WebsiteModule' }
    & Pick<SchemaTypes.WebsiteModule, 'id' | 'displayName' | 'email'>
    & { phone: (
      { __typename: 'Phone' }
      & Pick<SchemaTypes.Phone, 'value' | 'prefix'>
    ) }
  ) }
  & WebPageEndpointSpecsFragment
);

export const WebpageEndpointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment WebpageEndpointContextData on WebPageEndpoint {
  id
  pathname
  title
  websiteModule {
    id
    displayName
    phone {
      value
      prefix
    }
    email
  }
  webPageId
  ... on WebPageEndpoint {
    ...WebPageEndpointSpecs
  }
}
    `;